"use strict";

exports.__esModule = true;
var _DashboardListScreen = require("./DashboardListScreen");
Object.keys(_DashboardListScreen).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _DashboardListScreen[key]) return;
  exports[key] = _DashboardListScreen[key];
});